import { apiPost } from '../lib/apiClient';
import { getCurrentSession } from '../lib/authService';

export async function ensureUserRoleClaim() {
  try {
    const res = await apiPost('/auth/ensure-admin-role', {});
    return res;
  } catch (error) {
    console.warn('ensureUserRoleClaim failed:', error);
    const session = getCurrentSession();
    return { updated: false, role: session?.user?.role || 'user' };
  }
}
